import type { DiscountType } from "@shared/graphql.types";
import { useUser } from "lib/user";

export function useDiscounts(): DiscountType[] {
  const { discounts = [] } = useUser();

  return discounts;
}
